module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/radiocheckselect/asset/arrow.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/radiocheckselect/asset/arrow.png
// module id = 434
// module chunks = 418